"use client";

import { StickyButtonWrapper } from "@repo/components";
import { useEffect, useRef } from "react";
const ApplePayButton = ({
  locale,
  isApplePay,
  handlePlaceOrder
}) => {
  const applePayBtnRef = useRef(null);
  useEffect(() => {
    const button = applePayBtnRef.current;
    if (button && isApplePay) {
      const onClickHandler = () => {
        handlePlaceOrder();
      };
      button.addEventListener("click", onClickHandler);
      return () => {
        button.removeEventListener("click", onClickHandler);
      };
    }
  }, [handlePlaceOrder, isApplePay]);
  if (!isApplePay) return null;
  return <>
      <style jsx global>{`
        apple-pay-button {
          --apple-pay-button-width: 205px;
          --apple-pay-button-height: 44px;
          --apple-pay-button-border-radius: 0px;
          --apple-pay-button-padding: 0px 0px;
          --apple-pay-button-box-sizing: border-box;
        }
      `}</style>

      <StickyButtonWrapper data-sentry-element="StickyButtonWrapper" data-sentry-source-file="ApplePayButton.jsx">
        <apple-pay-button buttonstyle="black" type="plain" locale={locale === "ar" ? "ar-AB" : "en-US"} ref={applePayBtnRef} data-sentry-element="apple-pay-button" data-sentry-source-file="ApplePayButton.jsx" />
      </StickyButtonWrapper>
    </>;
};
export default ApplePayButton;